// extracted by mini-css-extract-plugin
var _1 = "styles-module__detailsRow___MVUWN";
var _2 = "styles-module__detailsTitle___f0ZLn";
var _3 = "styles-module__skipRow___yF_C5";
var _4 = "styles-module__titleCell___jC2Fg";
var _5 = "styles-module__titleRow___dp3UQ";
export { _1 as "detailsRow", _2 as "detailsTitle", _3 as "skipRow", _4 as "titleCell", _5 as "titleRow" }
